import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../auth/authentication.service';
import { HttpClient } from '@angular/common/http';
import { EndpointConfig } from '../../common/EndpointConfig';
import { IHttpService } from '../../common/IHttpService';
import { Paginator } from 'src/app/viewmodels/paginator';
import { GVehicleNotifyViewModel } from 'src/app/viewmodels/g-vehicle/GVehicleNotifyViewModel';
import { DefaultService } from '../../common/default.service';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';

@Injectable({
  providedIn: 'root'
})
export class VehicleNotifyService implements IHttpService<GVehicleNotifyViewModel> {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient, private _authenticationService: AuthenticationService,private _defaultService: DefaultService) {
    this._ep = new EndpointConfig('GVehicleNotify');
  }

  GetList() {
    return this._client.post(this._ep.getEndpointMethod('GetG_VehicleNotifyList') ,new Paginator(0, 50, null, 0));
  }
  GetPagedResult(start: number = 0, pageSize: number = 50, sortIndex: number = 0) {
    return this._client.post(this._ep.getEndpointMethod('GetG_VehicleNotifyList'), new Paginator(start, pageSize, null, sortIndex));
  }
  GetPagedResultBySort(start = 0, pagesize = 20, flag = '', sortIndex, SortBy) {
    debugger
    let pager = new Paginator();
    pager.PageSize = pagesize;
    pager.Skip = start;
    pager.Flag = flag;
    pager.SortIndex = sortIndex;
    pager.SortBy = SortBy;
    return this._client.post(this._ep.getEndpointMethod('GetG_VehicleNotifyList'), pager);
  }
  GetPagedBySearch(searchTerm) {
    let pager = new Paginator(0, 50, null, 0);
    pager.Search = searchTerm;
    return this._client.post(this._ep.getEndpointMethod('GetG_VehicleNotifyList'), pager);
  }
  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_VehicleNotifyById'), { Id: id });
  }
  Post(obj: GVehicleNotifyViewModel) {
    console.log(obj);
    debugger
    this._defaultService.dateTransFuckDatesInObject(obj);
    //obj.Fk_G_StatusType_Id = new ItemViewModel(E_G_EPSStatusType.SaleQout);

    let fd = new FormData();
    debugger
    if(obj.file!=undefined){
      for (var i = 0; i < obj.file.length; i++) {
      fd.append('file', obj.file[i]);
      }
    }
    fd.append('Obj',JSON.stringify(obj));
    return this._client.post(this._ep.getEndpointMethod('SaveG_VehicleNotify'), fd);
  }
  Put(obj: GVehicleNotifyViewModel) {
    console.log(obj);
    debugger
    this._defaultService.dateTransFuckDatesInObject(obj);
    //obj.Fk_G_StatusType_Id = new ItemViewModel(E_G_EPSStatusType.SaleQout);

    let fd = new FormData();
    debugger
    if(obj.file!=undefined){
      for (var i = 0; i < obj.file.length; i++) {
      fd.append('file', obj.file[i]);
      }
    }
    fd.append('Obj',JSON.stringify(obj));
    return this._client.post(this._ep.getEndpointMethod('SaveG_VehicleNotify'), fd);
  }
  Delete(obj: GVehicleNotifyViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_VehicleNotify'), obj);
  }
ExportVehicle(obj: ExportExcel) {
    let fd = new FormData();
    fd.append('Obj',JSON.stringify(obj));
    return this._client.post(this._ep.getEndpointMethod('VehiceleNotify_Export'), fd, {responseType: 'blob'});
  }
}
